import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { axios } from '@utils/lib';
import { Enums, Paths, Value } from '@utils/constants';

export const getAppSumaryDetailsAsync = createAsyncThunk(
  'api/getAppSumaryDetailsAsync',
  async (id: string, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<IResApplicationSumary>>(
        Enums.HTTP_METHOD.GET,
        Paths.APPLICATIONS + `/${id}?populate=user,ssid`,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const getDBSumaryPrivateAsync = createAsyncThunk(
  'api/getDBSumaryPrivateAsync',
  async (dataQuery: IDBSumaryQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { id, query } = dataQuery;
    const searchQuery: Record<string, string> = {
      'pagination[page]': query.page ?? Value.TABLE_PAGE_INIT,
      'pagination[pageSize]': query.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'createdAt:desc',
    };
    if (query.name) searchQuery['filters[name]'] = query.name;
    if (query.size) searchQuery['filters[size]'] = query.size;
    if (query.proximityAllowed)
      searchQuery['filters[proximityAllowed]'] =
        query.proximityAllowed === '1' ? 'true' : 'false';
    const params = new URLSearchParams(searchQuery).toString();
    try {
      const { data } = await axios.request<IListRes<IDatabaseSumaryList>>(
        Enums.HTTP_METHOD.GET,
        Paths.FACE_DB_PRIVATE.replace(':appId', id) + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
export const getDBSumaryClusterAsync = createAsyncThunk(
  'api/getDBSumaryClusterAsync',
  async (dataQuery: IDBSumaryQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { id, query } = dataQuery;
    const searchQuery: Record<string, string> = {
      'pagination[page]': query.page ?? Value.TABLE_PAGE_INIT,
      'pagination[pageSize]': query.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'createdAt:desc',
    };
    if (query.name) searchQuery['filters[name]'] = query.name;
    if (query.size) searchQuery['filters[size]'] = query.size;
    const params = new URLSearchParams(searchQuery).toString();
    try {
      const { data } = await axios.request<IListRes<IDatabaseSumaryList>>(
        Enums.HTTP_METHOD.GET,
        Paths.FACE_DB.replace(':appId', id) + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const changeMaxRecordAsync = createAsyncThunk(
  'api/changeMaxRecordAsync',
  async (body: IDBSumaryUpdateQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { appId, query } = body;
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PUT,
        Paths.UPDATE_FACE_DB_PRIVATE.replace(':appId', String(appId)).replace(
          ':id',
          String(query.id),
        ),
        { size: query.size },
        {},
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
